"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Options to attach to every mongoose schema by default
 */

exports.default = {
  toObject: { virtuals: true },
  toJSON: { virtuals: true },
  // Remove the "id as string" virtual
  id: false
};